import { IEntityOptionsService } from '../../../services/common/entity-options/entity-options-service';
import { IEntityOptionsRepository } from './entity-options-repository';

export class EntityOptionsRepositoryImpl implements IEntityOptionsRepository {
  constructor(private entityOptionsService: IEntityOptionsService) {}

  list(entity: string) {
    return this.entityOptionsService.list(entity);
  }
}
